<div class="w-full flex flex-col gt-xs:pr-3 pb-2">
  <!-- Styles applied to mimick mat-form-field label style -->
  <span class="block text-ellipsis overflow-hidden pointer-events-auto" [matTooltip]="fieldDef.label" [ngStyle]="{ color: '#6b7280', marginBottom: '2px' }" tooltipIfEllipsis>
    {{ fieldDef.label }}
  </span>

  <div class="textarea-quill-editor">
    <quill-editor
      class="w-full"
      [(ngModel)]="value"
      [maxLength]="10000"
      [disabled]="isDisabled"
      [spellcheck]="false"
      [modules]="quillModules"
      [quillEditorConditionalStyling]="fieldStyling().color"
      [blurContent]="fieldDef.meta?.value_hidden && !editing"
      (click)="edit()"
      (focus)="edit()"
      (onBlur)="onBlur()"
    ></quill-editor>
  </div>
</div>
